import { createI18n, LocaleMessageDictionary, VueMessageType } from "vue-i18n";
import { useStorage } from "@vueuse/core";
import koMessages from "./locales/ko";
import enMessages from "./locales/en";

const locale = useStorage("locale", "ko", window.localStorage);

export const i18n = createI18n({
  locale: locale.value ?? "ko",
  fallbackLocale: "en",
  legacy: false, // Vue 3 Composition API 최적화
  globalInjection: true, // 전역 주입 활성화
  silentTranslationWarn: true, // 번역 경고 무시
  silentFallbackWarn: true, // 폴백 경고 무시
  messages: {
    ko: koMessages,
    en: enMessages,
  },
});

export const loadLocaleMessages = (messages: any) => {
  if (!i18n || !i18n.global) {
    console.warn("i18n.global is not initialized yet");
    return; // i18n가 준비 안되었으면 함수 종료
  }

  Object.entries(messages).forEach(([key, value]) => {
    i18n.global.mergeLocaleMessage(key, value as LocaleMessageDictionary<VueMessageType>);
  });
};
